if (window.__POWERED_BY_QIANKUN__) {
  // eslint-disable-next-line camelcase,no-undef
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__
}
